// interfaces
import { PaymentFallbacks } from "@swiggy-private/payment-types";

// constants
import { TRY_OTHER_PAYMENT_METHODS } from "@payment-client/constants/TextDict";

export const DEFAULT_PAYMENT_FALLBACK_DATA: PaymentFallbacks = {
    failureTitle: "Transaction Failed",
    failureMessage: "Any amount deducted will be refunded within 2-4 days. How would you like to proceed?",
    failureIcon: "payment_failure_icon_gzp8qe",
    paymentMethods: [
        {
            name: "others",
            displayName: TRY_OTHER_PAYMENT_METHODS,
        },
    ],
};

export const PAYMENT_FALLBACK_TYPES = {
    COD: "COD",
    RETRY: "RETRY",
    TRY_OTHERS: "TRY_OTHERS",
    DISMISS: "DISMISS",
    PAYTM: "PayTM",
    FREE_CHARGE: "Freecharge",
    PHONEPE: "PhonePe",
    MOBIKWIK: "Mobikwik",
    LAZYPAY: "PayLater_Lazypay",
    SWIGGY_MONEY: "SwiggyPay",
    SIMPL: "PayLater_Simpl",
};
